import React from "react";
import PropTypes from "prop-types";
import Icon from "@xo-union/tk-component-icons";
import Styles from "./styles.css";
var ToggleButton = function ToggleButton(_ref) {
  var text = _ref.text,
    onClick = _ref.onClick,
    isOpen = _ref.isOpen,
    buttonRef = _ref.buttonRef;
  var iconName = isOpen ? 'arrow_up' : 'arrow_down';
  return /*#__PURE__*/React.createElement("button", {
    className: Styles.btn,
    onClick: onClick,
    ref: buttonRef
  }, text, /*#__PURE__*/React.createElement(Icon, {
    className: Styles.icon,
    name: iconName,
    size: "md"
  }));
};
process.env.NODE_ENV !== "production" ? ToggleButton.propTypes = {
  text: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonRef: PropTypes.object
} : void 0;
export default ToggleButton;